import { useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Stack,
  TextField,
} from "@mui/material";
import Iconify from "../../components/Iconify";
// hooks
import useResponsive from '../../hooks/useResponsive';
// utils
import { fKrNegoTimeKST } from "../../utils/formatTime";
import { LoadingButton } from "@mui/lab";


export default function NegoExtendDialog({ deadline, isOpen, close, extend, isSubmit }) {
  const smUp = useResponsive('up', 'sm');
  const [reason, setReason] = useState('');

  const closeDialog = () => {
    setReason('');
    close();
  };

  return (
    <Dialog open={isOpen} onClose={close} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
          <Iconify icon={"eva:alert-triangle-fill"} sx={{ width: 20, height: 20, color: 'error.main' }} />
          <Typography variant="subtitle2" sx={{ color: "error.main" }}>
            잠깐, 꼭 확인해주세요
          </Typography>
        </Stack>
        <Typography variant={smUp ? "h5" : "subtitle1"} gutterBottom>
          기한 연장은 단 한번만 가능합니다.
        </Typography>
        <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all", mb: 3 }}>
          연장시 기한이 <b>{fKrNegoTimeKST(deadline)}</b>로 변경됩니다.<br/>기한 연장 사유는 크루에게도 전달됩니다.
        </Typography>
        <TextField
          fullWidth
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          minRows={2}
          multiline
          placeholder="응답 기한 연장 사유를 적어주세요."
        />
      </DialogContent>
      <DialogActions>
        <Stack direction={{ xs: "column-reverse", sm: "row" }} sx={{ width: 1 }} spacing={1} justifyContent="flex-end">
          <LoadingButton
            onClick={closeDialog}
            size="large"
            sx={{ px: 4 }}
            loading={isSubmit}
          >
            취소
          </LoadingButton>
          <LoadingButton
            variant="contained"
            size="large"
            sx={{ px: 4 }}
            disabled={!reason}
            loading={isSubmit}
            onClick={() => extend(reason)}
          >
            기한 연장하기
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}